(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["avent-countdown"] && !Shopify.designMode) return;
  try {
    (() => {
    const DAY = 864e5;
    const build = (el) => {
      if (el.dataset.cdDone) return;
      el.dataset.cdDone = '1';
      const target = new Date(el.dataset.target);
      if (Number.isNaN(target.getTime())) return;
      const now = new Date();
      const days = Math.ceil((target - now) / DAY);
      const text = el.querySelector('[data-cd-text]');
      if (text) {
        if (days > 1) {
          const [a, b] = (el.dataset.labelBefore || '[n]').split('[n]');
          const n = document.createElement('b');
          n.textContent = String(days);
          text.replaceChildren(document.createTextNode(a || ''), n, document.createTextNode(b || ''));
        } else {
          text.textContent = days === 1 ? el.dataset.labelTomorrow || '' : el.dataset.labelAfter || '';
        }
      }

      /* Prochaine étape de la frise : la 1re date pas encore passée. */
      const steps = (el.dataset.steps || '').split(',').map((d) => d.trim()).filter(Boolean);
      if (!steps.length) return;
      const idx = steps.findIndex((d) => new Date(`${d}T23:59:59`) >= now);
      if (idx < 0) return;
      const scope = el.closest('.shopify-section') || document;
      const rows = [...scope.querySelectorAll('.group-block-content')].filter((row) => {
        if (row.contains(el)) return false;
        const kids = [...row.children];
        return kids.length === steps.length && kids.every((k) => k.matches('[data-testid="group-block"]'));
      });
      const row = rows[0];
      if (!row) return;
      [...row.children].forEach((k) => k.classList.remove('avent-step--now'));
      const step = row.children[idx];
      step.classList.add('avent-step--now');
      step.style.setProperty('--avent-now', getComputedStyle(el).getPropertyValue('--cd-now'));
    };
    const run = () => document.querySelectorAll('[data-avent-countdown]').forEach(build);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
    document.addEventListener('shopify:section:load', run);
  })();
  } catch(e) { console.error(e); }
})();

})();
